import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('create_new_organisation_in_approvalmax'),
    contentTitle: defineMessage('which_accounting_system_pprovalmax_organisation'),
    dearButton: defineMessage('connect_to_cin_core'),
    dearTitle: defineMessage('why_connection_matters'),
    dearDetailsText: defineMessage('itemconnecting_approval_in_core_immediatelyitem'),
    netSuiteButton: defineMessage('connect_to_oracle_netsuite_1'),
    netSuiteTitle: defineMessage('why_connection_matters'),
    netSuiteDetailsText: defineMessage('itemconnecting_approval_etsuite_immediatelyitem'),
    xeroButton: defineMessage('connect_to_xero'),
    xeroTitle: defineMessage('why_connection_matters'),
    xeroDetailsText: defineMessage('itemconnecting_approval_in_xero_immediatelyitem'),
    xeroProTip: defineMessage('pro_tip'),
    xeroProTipText: defineMessage('consider_connecting_to__morelearn_morelearnmore'),
    qboButton: defineMessage('connect_to_quickbooks_online_1'),
    qboTitle: defineMessage('why_connection_matters'),
    qboDetailsText: defineMessage('itemconnecting_approval__online_immediatelyitem'),
    connectLaterButton: defineMessage('connect_later'),
    connectLaterTitle: defineMessage('what_you_can_do_without_a_connection'),
    connectLaterDetailsText: defineMessage('itemyou_can_only_set_up_king_the_connectionitem'),
};
